export default __webpack_public_path__ + "static/media/dg-grey.e98a03e0.svg";